<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ManageContainerTypesTable from '@/components/manage/container-type/ManageContainerTypesTable.vue';
import { setTitle } from '@/utils/title';

const store = useStore();
const accountId = computed(() => store.getters['auth/accountId']);

setTitle('Container Types');
</script>

<template>
  <section class="max-w-[860px]">
    <ManageContainerTypesTable v-if="accountId" :accountId="accountId" />
  </section>
</template>
